






















import Vue from 'vue'

import dropZone from './drop-zone/drop-zone.vue'
import dropZoneDisabled from './drop-zone/drop-zone-disabled.vue'
import urlZone from './url-zone/url-zone.vue'
import fileList from './file-list/file-list.vue'
import style from './style.module.scss'

import { validateFiles } from '@/utils/validation'
import '@/polyfills.js'
import { nanoid } from 'nanoid'


import { FileModelExtended } from '@/types/common'

enum Mode {
  load = 1,
  link = 2
}

export default Vue.extend({
name: 'file-upload',
  components: {
    dropZone,
    dropZoneDisabled,
    urlZone,
    fileList
  },
  props: {
    enableUrl: Boolean,
    images: Boolean,
    files: Array as () => FileModelExtended[],
    title: String,
    maxFileSizeForUploading: {
      type: Number,
      default: 5242880, // 5Mb
    },
    extensions: {
      type: Array as () => string[],
      required: false,
      default: () => [ '7z', 'ace', 'doc', 'docx', 'gif', 'jpg', 'jpeg', 'ods', 'odt', 'pdf', 'png', 'rar', 'rtf', 'tif', 'txt', 'xls', 'xlsx', 'xps', 'zip' ]
    },
    singleMode: {
      type: Boolean,
      default: false,
      required: false
    },
    canEdit: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      s: style,
      mode: Mode.load,
      Mode,
    }
  },
  methods: {
    upload(filesRaw: File[]) {

      if(filesRaw) {
        const files = Array.from(filesRaw);
        const readers: FileReader[] = [];

        const validatedFiles = this.validateFiles(files, this.extensions, this.maxFileSizeForUploading);

        validatedFiles.valid.forEach((file, index) => {
            const reader = readers[index] = new FileReader();

            const fileObject: FileModelExtended = {
                LocalId: nanoid(5),
                Name: file.name,
                FileName: file.name,
                Content: null,
                Progress: 0,
                Edit: false
            }

            this.files.push(fileObject);

            reader.onload = (event: ProgressEvent) => {
                const target = event?.target as FileReader;

                fileObject.Content = target.result;
                fileObject.Progress = 100

                this.$emit('change', this.files)
            }

            reader.onprogress = (event: ProgressEvent) => {
                if (event.lengthComputable) {
                    fileObject.Progress = (event.loaded / event.total) * 100;
                }
            }

            if (file) {
                reader.readAsDataURL(file);
            }
        });
      }
      else
      {
        console.warn('nooo')
      }
    },
    uploadByUrl(url: string) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";

      const urlZoneComponent = this.$refs.errorURL as Vue;
      const urlZoneContainer = urlZoneComponent?.$el?.lastElementChild as HTMLElement;
      const urlZoneError = urlZoneContainer.lastElementChild as HTMLElement;

      xhr.onload = (event: ProgressEvent) => {

        const target = event.target as XMLHttpRequest;
        const file = target.response;
        const type = file.type;

        const valid = this.validateMimeTypes(type, this.extensions);

        if(valid) {
          const reader = new FileReader();
          urlZoneError.style.display = 'none';
          const fileObject: FileModelExtended = {
            LocalId: nanoid(5),
            Name: url,
            FileName: file.name,
            Content: null,
            Progress: 0,
            Edit: false
          }

          this.files.push(fileObject);

          reader.onload = (event: ProgressEvent) => {
            const target = event?.target as FileReader;

            fileObject.Content = target.result;

            this.$emit('change', this.files)
          }

          reader.onprogress = (event: ProgressEvent) => {

            if (event.lengthComputable) {
                const progress = (event.loaded / event.total) * 100;
                fileObject.Progress = progress;
            }
          }

          reader.readAsDataURL(file)
        }
      }

      xhr.onerror = () => {
          urlZoneError.style.display = 'block';
      }

      xhr.send()

    },
    removeFile(localId: string) {
      this.$emit('change', this.files.filter((file) => file.LocalId != localId))
    },
    validateMimeTypes(type: string, extentions: string[]): boolean {
      //пока только для изображений
      let valid = false;

      for (let index = 0; index < extentions.length; index++) {
        const item = extentions[index];
        if(type.includes(item)) {
          valid = type.includes(item);
          break;
        }
      }
      return valid
    },
    validateFiles
  }
})
